import { useEffect, useState } from "react";
import { AppBar, Box, Collapse, Container, Grid, ThemeProvider, Toolbar, useMediaQuery, useTheme } from "@mui/material";

import { useNavigate } from "react-router-dom";
import { fetchAuthSession } from "aws-amplify/auth";
import { DialogsProvider } from "@toolpad/core/useDialogs";

import { RootState } from "@store/store.ts";
import { useDispatch, useSelector } from "react-redux";
import { setSignInStep } from "@store/slices/authSlice.ts";
import { BackOfficeTheme } from "@themes/BackOfficeTheme.ts";

import { FormularioMFA } from "../components/FormularioMFA.tsx";
import { FormularioInicioSesion } from "../components/FormularioInicioSesion.tsx";
import { FormularioCuentaBloqueada } from "../components/FormularioCuentaBloqueada.tsx";
import { FormularioCambioContrasenia } from "../components/FormularioCambioContrasenia.tsx";
import { FormularioRecuperacionContrasenia } from "../components/FormularioRecuperacionContrasenia.tsx";

import RightImg from "@assets/right_1.svg";
import LendiaIcon from "@assets/lendia_icon.svg";
import BackgroundLogin from "@assets/background_login.svg";

export default function Login() {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

    const [email, setEmail] = useState<string>("");

    const authState = useSelector((state: RootState) => state.auth);

    useEffect(() => {
        fetchAuthSession().then((value) => {
            if (value.tokens === undefined) {
                dispatch(setSignInStep("LOGIN"));
                navigate("/");
            } else if (authState.signInStep === "WELCOME") {
                navigate("/solicitudes");
            }
        });

        if (authState.isAuthenticate === false && authState.isVerified === false) {
            dispatch(setSignInStep("LOGIN"));
        }

        if (localStorage.getItem("email")) {
            setEmail(localStorage.getItem("email") ?? "");
        }
    }, []);

    return (
        <>
            <DialogsProvider>
                <ThemeProvider theme={BackOfficeTheme}>
                    <AppBar position="static">
                        <Toolbar sx={{ backgroundColor: "#fff" }}>
                            <Box
                                component="img"
                                src={`${import.meta.env.VITE_URL_STATIC_RESOURCES}/lendia/bpm/logo.svg`}
                                alt={"Lendia"}
                                sx={{ width: 160 }}
                            />
                        </Toolbar>
                        <Container sx={{ height: "95.3vh", minWidth: "100%", p: "0 !important" }}>
                            <Grid container height={"100%"} alignItems={"center"}>
                                <Grid
                                    container
                                    size={{ xs: isMobileOrTablet ? 12 : 7 }}
                                    height={"100%"}
                                    alignItems={"center"}
                                    sx={{
                                        backgroundColor: "#fdfdfd",
                                        backgroundImage: `url("${BackgroundLogin}")`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        backgroundRepeat: "no-repeat",
                                    }}
                                >
                                    <Container
                                        sx={{
                                            width: "50%",
                                            minWidth: "420px",
                                            minHeight: "600px",
                                            backgroundColor: "#FFFFFF",
                                            borderRadius: "8px",
                                            boxShadow: "8px 4px 20px 0px #58585840",
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={LendiaIcon}
                                            alt={"Lendia"}
                                            sx={{
                                                width: 50,
                                                position: "relative",
                                                right: "0px",
                                                top: "20px",
                                            }}
                                        />

                                        <Collapse in={authState.signInStep === "LOGIN"} unmountOnExit>
                                            <FormularioInicioSesion />
                                        </Collapse>
                                        <Collapse in={authState.signInStep === "MFA"} unmountOnExit>
                                            <FormularioMFA email={email} />
                                        </Collapse>
                                        <Collapse in={authState.signInStep === "BLOCKED"}>
                                            <FormularioCuentaBloqueada email={email} />
                                        </Collapse>
                                        <Collapse in={authState.signInStep === "RESET_PASS"}>
                                            <FormularioRecuperacionContrasenia />
                                        </Collapse>
                                        <Collapse in={authState.signInStep === "NEW_PASSWORD"}>
                                            <FormularioCambioContrasenia />
                                        </Collapse>
                                    </Container>
                                </Grid>
                                {!isMobileOrTablet && (
                                    <Grid
                                        size={{ xs: 12, md: 5 }}
                                        height={"100%"}
                                        width={"100%"}
                                        textAlign={"center"}
                                        sx={{ backgroundColor: "#052649" }}
                                    >
                                        <img
                                            src={RightImg}
                                            alt=""
                                            style={{ height: "calc(100vh - 160px)", width: "100%" }}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </Container>
                    </AppBar>
                </ThemeProvider>
            </DialogsProvider>
        </>
    );
}
